export enum DefaultView {
    Date = 1,
    Month = 2,
    Year = 3
}
